<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            Address book
            <p class="subtitle" *ngIf="!loading && cart && cart.organisation">{{cart.organisation.title}}</p>
            <p class="subtitle" *ngIf="!loading && cart && !cart.organisation && cart.person">
                <span *ngIf="cart.person.full_name">{{cart.person.full_name}} (#{{cart.person.number}})</span>
                <span *ngIf="!cart.person.full_name">#{{cart.person.number}}</span>
            </p>
        </ion-title>
        <ion-buttons slot="end">
            <ion-button *ngIf="!loading && online" (click)="presentAddShippingAddressModal()">
                <fa-icon [icon]="['far', 'plus']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <ion-toolbar>
        <ion-searchbar placeholder="Name, organisation or address" debounce="500" [(ngModel)]="keywords" (ionInput)="searchAddresses()"></ion-searchbar>
    </ion-toolbar>

</ion-header>

<ion-content>

    <table *ngIf="online && !loading && visible_addresses && visible_addresses.length != 0" class="datatable full-bleed">
        <thead>
            <tr>
                <th class="no-wrap">Name</th>
                <th class="no-wrap">Organisation</th>
                <th class="no-wrap">Address</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let address of visible_addresses; let i = index" class="ion-activatable ripple-parent button-row" (click)="select(i)">
                <td class="if-empty-na">
                    <ng-container *ngIf="address.first_name">{{address.first_name}} </ng-container>
                    <ng-container *ngIf="address.last_name">{{address.last_name}}</ng-container>
                </td>
                <td class="if-empty-na">
                    <ng-container *ngIf="address.organisation_title">{{address.organisation_title}}</ng-container>
                </td>
                <td>
                    <ng-container *ngIf="address.line_1">{{address.line_1}}</ng-container>
                    <ng-container *ngIf="address.line_2"><br>{{address.line_2}}</ng-container>
                    <ng-container *ngIf="address.locality"><br>{{address.locality}}</ng-container>
                    <ng-container *ngIf="address.subdivision"><br>{{address.subdivision}}</ng-container>
                    <ng-container *ngIf="address.postal_code"><br>{{address.postal_code}}</ng-container>
                    <ng-container *ngIf="address.country_title"><br>{{address.country_title}}</ng-container>
                </td>

                <!-- NOTE: this is required for the ripple effect on IOS -->
                <div class="ripple-pseudo-element">
                    <ion-ripple-effect></ion-ripple-effect>
                </div>

            </tr>
        </tbody>
    </table>

    <ion-infinite-scroll *ngIf="!loading && visible_addresses && visible_addresses.length != 0" threshold="100px" (ionInfinite)="showMoreVisibleAddresses($event)">
        <ion-infinite-scroll-content loadingSpinner="crescent" loadingText="Loading"></ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <ion-grid *ngIf="online && !loading && visible_addresses && visible_addresses.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'address-book']" size="6x"></fa-icon>
                    <span>No addresses found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>

    <!-- skeleton text -->
    <table *ngIf="loading" class="datatable">
        <thead>
            <tr>
                <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>
                <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>
                <th><ion-skeleton-text [animated]="true" style="width: 140px; height: 20px"></ion-skeleton-text></th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let n of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]">
                <td><ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text></td>
                <td><ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text></td>
                <td>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                    <ion-skeleton-text [animated]="true" style="width: 120px; height: 15px"></ion-skeleton-text>
                </td>
            </tr>
        </tbody>
    </table>

</ion-content>

